import SessionContext from "../contexts/session";
import { useTranslation, Trans } from "react-i18next";
import {
  Button,
  DialogTitle,
  Dialog,
  Typography,
  Alert,
  Box,
  Divider,
  IconButton,
  Stack,
} from "@mui/material";
import { useCallback, useContext } from "react";
import NETWORKS from "../networks";
import { useDisconnect, useSwitchNetwork } from "wagmi";

export default function ChangeNetworks() {
  const { selectedNetwork, isNetworkSwitching, setIsNetworkSwitching } =
    useContext(SessionContext);

  const handleClickOpen = () => {
    setIsNetworkSwitching(true);
  };

  const handleClose = (value) => {
    setIsNetworkSwitching(false);
  };

  return (
    <div>
      <>
        <Box sx={{ display: { xs: "none", sm: "flex" } }}>
          <Button
            onClick={handleClickOpen}
            color="black"
            variant="contained"
            startIcon={<img height={24} src={selectedNetwork.ui.menuIcon2} />}
            sx={{
              textTransform: "none",
              ".MuiButton-startIcon": {
                mr: { xs: 0, sm: "0.5rem" },
              },
            }}
          >
            <Box sx={{ display: { xs: "none", sm: "flex" } }}>
              {selectedNetwork.chainName}
            </Box>
          </Button>
        </Box>
        <Box sx={{ display: { xs: "flex", sm: "none" } }}>
          <IconButton
            sx={{
              background: selectedNetwork.ui.gradient,
            }}
            onClick={handleClickOpen}
          >
            <img height={24} src={selectedNetwork.ui.menuIcon} />
          </IconButton>
        </Box>
      </>

      {isNetworkSwitching && (
        <SimpleDialog open={isNetworkSwitching} onClose={handleClose} />
      )}
    </div>
  );
}

function SimpleDialog({ onClose }) {
  const { t } = useTranslation();
  const { disconnect } = useDisconnect();

  const { error, isLoading, pendingChainId, switchNetwork } =
    useSwitchNetwork();

  const {
    account,
    selectedNetwork,
    setSelectedNetwork,
    isNetworkSwitching,
    wrongNetwork,
  } = useContext(SessionContext);

  const handleClose = useCallback(() => {
    if (!isLoading) {
      onClose();
    }
  }, [isLoading, onClose]);

  const handleListItemClick = (network) => {
    if (account) {
      switchNetwork(network.chainIdDec);
    } else {
      setSelectedNetwork(network);
      onClose();
    }
  };

  // if (error?.name === "UserRejectedRequestError") {
  //   onClose();
  // }

  // useEffect(() => {
  //   if (pendingChainId) {
  //     handleClose();
  //   }
  // }, [handleClose, pendingChainId, selectedNetwork]);

  function handleLogoutClick() {
    disconnect();
    onClose();
  }

  return (
    <Dialog onClose={handleClose} open={isNetworkSwitching}>
      <DialogTitle>
        <Trans t={t}>Switch Networks</Trans>
      </DialogTitle>
      <Box
        sx={{
          px: 1,
          py: 1,
          display: "flex",
          flexDirection: "column",
          maxWidth: 350,
          gap: "0.5rem",
        }}
      >
        {wrongNetwork && (
          <Alert
            severity="error"
            sx={{ textAlign: "center", wordWrap: "break-word" }}
          >
            <Trans t={t}>
              Wrong network detected, switch or disconnect to continue.
            </Trans>
          </Alert>
        )}
        {error && (
          <Typography
            color="error"
            sx={{ textAlign: "center", wordWrap: "break-word" }}
          >
            {error.message}
          </Typography>
        )}

        <Stack>
          {Object.values(NETWORKS).filter(network => !network.disabled).map((network) => (
            <Box
              onClick={() => handleListItemClick(network)}
              key={network.chainId}
              sx={{
                px: 2,
                py: 1,
                borderRadius: 0.5,
                gap: "0.5rem",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                marginRight: { xs: 0, sm: 4 },
                width: "100%",
                backgroundColor:
                  selectedNetwork.chainId === network.chainId
                    ? "#3898ff"
                    : null,
                ...(selectedNetwork.chainId !== network.chainId && {
                  ":hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.1)",
                  },
                }),
              }}
            >
              <img height={28} src={network.ui.menuIcon2} />
              {network.chainName}
              {(selectedNetwork.chainId === network.chainId ||
                (isLoading && pendingChainId === network.chainIdDec)) && (
                <Box
                  sx={{
                    marginLeft: "auto",

                    display: "flex",
                    alignItems: "center",
                    gap: "0.25rem",
                  }}
                >
                  <Box
                    sx={{
                      color:
                        selectedNetwork.chainIdDec === network.chainIdDec
                          ? "success.main"
                          : "warning.main",
                    }}
                  >
                    ●
                  </Box>
                  {selectedNetwork.chainIdDec === network.chainIdDec
                    ? t("Selected")
                    : t("Switching")}
                </Box>
              )}
            </Box>
          ))}
        </Stack>
        {wrongNetwork && (
          <>
            <Divider />
            <Button
              variant="outlined"
              color="error"
              onClick={handleLogoutClick}
            >
              Disconnect
            </Button>
            <Button
              variant="outlined"
              color="error"
              onClick={handleLogoutClick}
            >
              <Trans t={t}>Disconnect</Trans>
            </Button>
          </>
        )}
      </Box>
    </Dialog>
  );
}
